export const TRANSLATIONS_ZH = {
  leftNavigation: {
    dashboard: "仪表盘",
    sessions: "辅导",
    teams: "团队",
    profile: "档案",
    logs: "记录",
    warningLetters: "警告信",
    settings: "设置",
    userManagement: "用户管理",
    subjectManagement: "主题管理",
    changePassword: "更改密码",
    helpAndSupport: "帮助&支持",
    scoresheet: "Scoresheet",
  },
  header: {
    logout: "注销",
    notifications: "通知",
    loadingNotifications: "Loading 通知....",
    stepper: {
      plan: "计划",
      do: "执行",
      check: "检验",
      act: "行动",
    },
  },
  tabs: {
    ceo: "CEO",
    executive: "管理层",
    coe: "COE",
    campaign: "项目",
    team: "团队",
    personal: "Personal",
  },
  notification: {
    session: "You have a coaching session with ",
    on: "on ",
    checkpointUpdated: "has updated the checkpoint date",
    complete: "Please complete the GROW Model by",
    growmodel: "has completed the GROW Model and accepted your invitation",
    progression: "has updated Your progression ",
    compliment: "gave you a compliment!'",
    rating: "Please rate your coaching session with",
    review: "has changed your final review date to",
    archivedSession: "has rated and archived the coaching session!",
    checkpoint: "Checkpoint",
    updateFor: "update for",
    isAvailable: "is available",
    at: "at",
    today: "today",
    youHaveYetToSetCheckPoint: "You have yet to set checkpoint for",
    by: "by",
    youHaveAReviewSessionWith: "You have a review session with",
    youHaveUpcomingSession: "You have an upcoming session with",
    youHaveCompleted: "You have completed",
    sessionCompletedLastMonth: "session(s) in the last month",
  },
  dashboard: {
    title: "仪表盘",
    noDataYet: "尚无数据",
    tabs: {
      ceo: "CEO",
      executive: "管理层",
      coe: "COE",
      campaign: "项目",
      team: "团队",
      personal: "Personal",
    },
    coachingSessionWith: "Coaching Session With",
    checkpointSetupFor: "Checkpoint setup for",
    checkpointUpdateFor: "Checkpoint update for",
    reviewSessionWith: "Review session with",
    average: "平均",
    longest: "最长",
    shortest: "最短",
    executive: {
      sessionClosed: "辅导结束",
      overall: "总体",
      totalInprogress: "Total in progress",
      avgUsageRate: "Avg usage rate",
      usageRate: "Usage rate",
      totalSessionClosed: "关闭的辅导总数",
      totalCoachees: "被辅导者总数",
      avgSessionClosed: "平均结束的辅导",
      coachingHours: "辅导时长",
      totalCoachingHours: "辅导总时数",
      avgCoachingHours: "平均辅导时间",
      totalPlanDuration: "计划总时长",
      totalDoDuration: "执行总时间",
      totalCheckDuration: "检验总时间",
      totalActDuration: "行动总时间",
      coachingSubjects: "辅导主题",
    },
    coach: {
      dashboard: "仪表盘",
      report: "报告",
      upcomingTask: "临近任务",
      overdueTask: "逾期任务",
      recentTask: "近期活动",
      top3coaches: "前3名辅导员",
      campaignSession: "项目的辅导",
      totalCoach: "总计被辅导者",
      coached2OrMoreSession: "已辅导2次或更多",
      coached1Session: "已辅导1次",
      notCoachedYet: "未进行辅导",
      showResultFor: "显示结果",
      happiness: "满意度",
      complimentLikes: "点赞",
      success: "成功率",
      ratedSession: "已评分辅导",
      totalSession: "总计辅导",
      likes: "喜欢",
      totalComplements: "总计点赞",
      passRate: "通过率",
      totalSubjects: "总计主题",
      comparedTo: "比较",
      mostCoachedSubjects: "辅导最多的主题",
      average: "平均",
      mostFailedSubjects: "失败最多的主题",
      topSkillsToImprove: "最需要提高的技能",
      teamAverage: "团队平均分",
      coach: "辅导员",
      typeOfSession: "辅导类型",
      subjects: "主题",
      session: "辅导",
      sessionDuration: "辅导时长",
      length: "时长",
      minutes: "分钟",
      longest: "最长",
      shortest: "最短",
      plan: "计划",
      do: "执行",
      check: "检验",
      act: "行动",
      total: "总计",
      individual: "个人",
      metricsHead: "团队成员被辅导次数",
      complianceRate: "遵守率",
      incompleteRate: "未完成率",
      conditionalPassRate: "有条件通过率",
      campaign: "项目",
      sessions: "辅导",
      manual: "手动",
      expired: "过期",
      team: "团队",
      campaignAverage: "项目平均",
      topCountries: "最靠前的国家",
    },
    personal: {
      dashboard: "仪表盘",
      showResultFor: "显示结果",
      happiness: "满意度",
      complimentLikes: "点赞",
      success: "成功率",
      ratedSession: "已评分辅导",
      totalSession: "总次数",
      likes: "喜欢",
      totalComplements: "总计点赞",
      passRate: "通过率",
      totalSubjects: "总计主题",
      latestCompliments: "最新点赞",
      comparedToTeamAvg: "与团队平均水平相比",
      mostCoachedSubjects: "辅导最多的主题",
      mostFailedSubjects: "失败最多的主题",
      topSkillsToImprove: "最需要提高的技能",
      individual: "个人",
      teamAverage: "团队平均值",
      subjects: "主题",
      session: "辅导",
    },
    selectReport: "Select Report",
    overallCoachingSessionsReport: "Overall Coaching Sessions Report",
    sessionDiscussionReport: "Session Discussion Report",
    monthly: "Monthly",
    custom: "Custom",
    cancel: "Cancel",
    download: "Download",
  },
  sessionList: {
    title: "辅导",
    totalSessionPending: "全部待定辅导",
    allCoaches: "所有被辅导者",
    allStatus: "所有状态",
    upcomingSession: "即将进行的辅导",
    sessionDateTime: "Session Date",
    time: "时间",
    type: "类别",
    subjects: "主题",
    coach: "辅导员",
    coachee: "被辅导者",
    status: "状态",
    createSession: "创建辅导环节",
    allCountries: "所有国家",
    allCampaign: "所有活动",
    sessionSuccess: "辅导环节成功结束",
    name: "名称",
  },
  createSession: {
    backToSession: "返回到辅导环节",
    createNewSession: "创建新的辅导环节",
    campaign: "项目",
    coachee: "Coachee",
    coach: "Coach",
    assignToOtherCoach: "分配给其他辅导员",
    assignTo: "分配给",
    selectTeamMember: "选择一个团队成员",
    viewCoacheesStates: "查看辅导历史记录",
    coachingDate: "辅导日期",
    method: "方法",
    framework: "框架",
    reviewDate: "审查日期",
    typeOfSession: "辅导类型",
    addSubjects: "添加主题",
    sessionNotes: "辅导环节说明",
    keyPoint: "关键点",
    addNewNote: "添加一个新的注释",
    compliment: "赞扬",
    casualNote: "非正式说明",
    createSendInvitation: "创建并发送邀请",
    assignFieldMandatory: "分配字段是强制性的",
    coacheeFieldMandatory: "被辅导者字段是强制性的",
    logs: "记录",
    complettionDate: "完成日期",
    duration: "时间",
    type: "类型",
    subjects: "主题",
    name: "名称",
    status: "状态",
    noTeamLogsFound: "没有发现团队日志",
    close: "关闭",
    methodIsMandatory: "方法是强制性的",
    frameworkIsMandatory: "框架是强制性的",
    sessionTypeIsMandatory: "辅导环节类型是必须的",
    pleaseAddAtLeastOneSubject: "请至少添加一个主题",
    selectAcoach: "选择一个辅导员",
    ErrorNetworkError: "错误:网络错误",
    notes: "笔记",
  },
  sessionDetails: {
    backtosession: "回到辅导环节",
    sessionDetails: "辅导环节详情",
    coach: "辅导员",
    coachee: "被辅导者",
    caochingDate: "辅导日期",
    reviewDate: "审查日期",
    typeofSession: "辅导环节类型",
    subjects: "主题",
    gentleReminderTitle: "温馨提醒",
    gentleReminder: "温馨提醒：在开始准备辅导环节之前，请阅读右侧的要点。",
    startPreparation: "开始准备",
  },
  growForm: {
    planSessionBasedonGrowModel: "基于GROW模型计划辅导环节",
    yourReviewSessionIsOn: "你的审查环节是关于",
    goals: "目标",
    comment: "评论",
    knowingYourCoachingSubjectsAndCreate:
      "了解你的辅导主题，并利用SMART目标制定一个计划，以便在审查日期前达到目标。",
    SMARTGolasIsAnEstablished:
      "SMART目标是一种计划和实现目标的既定方式。创建SMART目标有助于实现你想要完成的目标，如何实现你的目标，你的目标是否可以完成和相关，以及你想何时完成你的目标。",
    reality: "现状",
    current: "当前",
    target: "目标",
    enterMetrics: "输入衡量标准",
    knowingYourCurrentPerformance: "了解你目前与你的辅导主题有关的表现。",
    options: "选项",
    brainstormForMultipleOptionsToImprove:
      "集思广益，提出多种方案，以改善辅导主题，实现目标。列举可能的技术，以帮助关闭机会领域。这个阶段鼓励创造性地探索可能的解决方案",
    wayForward: "下一步",
    selectTheMostFeasibleOptions: "选择最可行的方案，以成功达到你的目标。",
    saveAndConfirmSession: "保存并确认会话",
    startCoachingSession: "开始辅导环节",
    edit: "编辑",
    startCoaching: "开始辅导",
    proceedToSummary: "进入总结",
    skillToImprove: "要改进的技能",
    selectSkill: "选择技能",
    pleaseSelectSkillsToImprove: "请选择要提高的技能",
    enterProjectKpi: "Enter Project Target KPI",
    projectTargetKpi: "Project Target KPI",
  },
  coachingSummary: {
    coachingSummary: "辅导总结",
    coach: "辅导员",
    coachee: "被辅导者",
    coachingDate: "辅导日期",
    method: "方法",
    typeOfSession: "辅导类型",
    goals: "目标",
    reality: "现状",
    current: "当前",
    target: "目标",
    skillToImprove: "要提高的技能",
    options: "选择",
    wayForward: "下一步",
    yourReviewSessionWillBe: "您的审查环节将在",
    progressionCheckpoints: "您的辅导员将在您的复查日期前设定并更新检查点进展",
    acknowledgement: "确认",
    enterPassword: "输入密码",
    pleaseEnterPassword: "请输入您的密码",
    endCoaching: "结束辅导",
    byAcknowledgingthisGrow:
      "通过确认本GROW表格，您同意按照所述行动计划进行工作。",
    cancel: "取消",
    agree: "同意",
  },
  setCheckpoint: {
    backToSession: "返回到辅导环节",
    setCheckpoint: "设置检查点",
    viewSessionSummary: "查看辅导环节摘要",
    rateCoacheesBehaviour: "评价被辅导者的行为",
    checkpoint: "检查点1",
    addCheckpoint: "增加检查点",
    reviewDate: "审查日期",
    gentleReminder:
      "温馨提醒。在您确认了评级和检查点之后，您将无法改变被辅导者的行为评分。",
    pleaseRateTheCoachees: "请给被辅导者的行为评分。",
    confirmRatingAndCheckpoints: "确认评分和检查点",
  },
  sessionSummary: {
    viewSessionSummary: "查看辅导环节摘要",
    coach: "辅导员",
    coachee: "被辅导者",
    coachingDate: "辅导日期",
    method: "方法",
    typeOfSession: "辅导类型",
    goals: "目标",
    reality: "现状",
    current: "当前",
    target: "目标",
    skillsToImprove: "要提高的技能",
    options: "选项",
    wayForward: "下一步",
  },
  updateCheckpoint: {
    updateCheckpoint: "更新检查点的分数",
    edit: "编辑",
    viewSessionSummary: "查看辅导环节摘要",
    reviewDate: "审查日期",
    checkpoint: "检查点",
    final: "最后",
    previous: "上一个",
    checkpointProgressScore: "检查点进度得分已成功保存",
    saveProgress: "保存进度分数",
    startReviewSession: "开始审查环节",
    postPoneReviewSession: "推迟审查环节",
    postPoneReviewSessionTo: "将审查环节推迟到",
    pleaseStateReason: "请说明原因",
    cancel: "取消",
    schedule: "日程",
  },
  reviewSession: {
    reviewSession: "审查环节",
    finalReview: "最终审查",
    final: "最后",
    summary: "总结",
    proceedToSummary: "进入总结",
    summaryFieldIsRequired: "总结是必填字段",
    sessionReviewSummarySavedSuccessfully: "辅导环节审查总结成功保存!",
    endReviewSession: "结束审查环节",
    done: "完成...!",
  },
  archiveSession: {
    backtoSession: "回到辅导",
    backToLog: "Back to Logs",
    archiveSession: "归档辅导",
    areYouSatisfied: "您对此次辅导满意吗？",
    pleaseReadTHeSessionSummary:
      '请仔细阅读辅导摘要和笔记。一旦此次辅导被归档，您就不能再 "喜欢 "来赞美笔记了。',
    totalDuration: "总时间",
    durationBreakdown: "时间细分",
    viewReviewSessionSummary: "查看辅导摘要",
    coacheesBehaviour: "被辅导者的行为",
    reviewDate: "查看日期",
    finalReview: "最终审查",
    summary: "摘要",
    notes: "备注",
    selectYourFeedback: "选择你的反馈",
  },
  personalProfile: {
    fullName: "全名",
    employeeID: "员工ID",
    campaign: "项目",
    market: "市场",
    designation: "职务",
    coach: "辅导员",
    viewSession: "查看辅导",
    viewLogs: "查看日志",
    personalProfile: "个人资料",
  },
  teams: {
    coach: "辅导员",
    taggedCoaches: "标记的被辅导者",
    untaggedCoachees: "未标记的被辅导者",
    searchFilter: "搜索过滤器",
    employeeId: "员工ID",
    Campaign: "项目",
    department: "部门",
    subunit: "亚基",
    lastSession: "上一次辅导",
    upcommingSession: "即将到来的辅导",
    totalCoachees: "被辅导者总数",
    members: "成员",
    coaches: "被辅导者",
    allCountries: "所有国家",
    allCampign: "所有项目",
    teams: "团队",
    name: "名称",
  },
  logs: {
    allCoaches: "所有被辅导者",
    searchFilter: "搜索过滤器",
    completionDate: "完成日期",
    duration: "时间",
    subjects: "主题",
    coach: "辅导员",
    coachee: "被辅导者",
    status: "状态",
    totalLogs: "总记录",
    type: "Type",
    averageDuration: "平均时间（分钟）",
    longestDuration: "最长时间（分钟）",
    shortestDuration: "最短时间（分钟）",
    filter: "筛选",
    names: "名称",
    name: "名称",
    clearAll: "清除所有",
    allCountries: "所有国家",
    AllCampaign: "所有项目",
  },
  userManagement: {
    searchFilter: "搜索过滤器",
    name: "姓名",
    id: "ID",
    campaign: "项目",
    department: "部门",
    country: "国家",
    designation: "职务",
    role: "角色",
    status: "状态",
    editUser: "编辑用户",
    fullName: "全名",
    employeeID: "员工ID",
    adminRole: "管理员角色",
    managerCoache: "管理被辅导者",
    AddCoach: "添加辅导员",
    userStatus: "用户状态",
    resetPassword: "重置密码",
    saveChanges: "保存更改",
    cancel: "取消",
    add: "添加",
    userDetailsUp: "用户资料更新成功",
    pleaseSaveToResetThe: "请保存以重置密码。",
  },
  subjectManagement: {
    searchFilter: "搜索过滤器",
    campaign: "项目",
    department: "部门",
    lastEdited: "最后编辑",
    date: "日期",
    subjectFor: "主题为",
    status: "状态",
    country: "国家",
    coachingCategory: "辅导类别",
    subCategory: "子类别",
    dataType: "数据类型",
    conditionToPass: "通过的条件",
    framework: "框架",
    enterSubCategory: "输入子类别",
    selectType: "选择类型",
    selectCondition: "选择要通过的条件",
    selectFramework: "选择框架",
    addSubCategory: "添加子类别",
    skillToImprove: "要提高的技能",
    enterSkillToImprove: "输入要提高的技能",
    addLevel: "添加级别",
    addSkillToImprove: "添加要提高的技能",
    actionAtCheckpoint: "检查点的行动",
    enterAction: "输入行动",
    addAction: "添加行动",
    saveChanges: "保存更改",
    cancel: "取消",
    editSubject: "编辑主题",
    subjectDetails: "主题细节已更新",
    noRecordFound: "没有找到记录",
    somethingWentWrong: "出了点问题，请稍后再试...!",
    functionalUnit: "Sub Functional Unit",
  },
  changePassword: {
    enterYourCurrentPassowrd: "输入您的当前密码",
    chooseAStrongPassword: "请选择一个强密码，不要在其他账户上重复使用。",
    newPassword: "新密码",
    passwordStrength: "密码强度",
    useAtLeast12Charecters:
      "至少使用12个字符。不要使用其他网站的密码，也不要使用太明显的",
    confirmNewPassword: "确认新密码",
    changePassword: "更改密码",
    thePasswordDoNotMatch: "密码不匹配!",
    passwordMustBeAtLeast12:
      "密码必须至少有12个字符，一个数字，一个特殊字符和一个大写字母",
    passwordCannotBeSameAsOldPassword: "New password cannot be same as old password",
  },
  error: {
    loginerror: "Uh-oh, either your details are incorrect, or your account’s inactive",
    usererror: "user is not active",
    internalServerError: "something went wrong, please try again",
    networkerror: {
      500: "Something went wrong",
    },
    paramerror: "'Value of ' + property + ' can not be null.",
    passwordvalidationerror:
      "Password must be at least 10 characters long, one number, one special character and one upper case letter",
    newpasswordvalidationerror: "new password and confirm doesn't match",
    oldpasswordvalidationerror: "old password doesn't match",
    successpasswordvalidationerror: "password successfully changed",
    noSessionDetailsFound: "No session details found",
    verbalWarningIssued: "Verbal warning issued",
    verbalWarningIssueFailed: "Failed to issue verbal warning, try again",
    alreadyTwoVerbalWarningIssued:
      "Already 2 verbal warning issued, try for other",
    checkpointProgressScoreHasBeenSavedSuccessfully:
      "Checkpoint Progress Score has been saved successfully",
    updatedCheckpointsSuccessfully: "Updated Checkpoints successfully",
    sessionReviewSummaryHasBeenSavedSuccessfully:
      "Session Review Summary has been saved successfully",
    selectedCoachIsAlreadyInTheList: "Selected Coach is already in the list",
    somethingWentWrongPleaseTryAgain: "something went wrong, please try again",
    couldNotGetSession: "Could not get session.",
    selectedCoacheeIsAlreadyBeenAdded: "Selected coachee is already been added",
    selectedCountryIsAlreadyInTheList:
      "Selected Country is already in the list",
    canNotUpdateActionAtCheckPoint: "can't update action_at_checkpoint!",
    couldNotGetCountryList: "Could not get Country List",
    couldNotGetNotification: "Could not get notification",
    errorGettingReviewDateSummary: "Error getting Review Date Summary",
    pleaseSelectCoachee: "Please select Coachee",
    couldNotGetGrowFormDetailsFromSessionId:
      "Could not get grow form details from session id",
    pleaseSelectSubjectAndAddMetrics: "Please select subject and add metrics",
    couldNotGetSkillsListBasedOnSubjectId:
      "Could not get Skills list based on subject id",
  },
  editSessionCoachingDates: {
    title: "Postpone Session Dates",
    update: "Update",
  },
  common: {
    noRecordFound: "No record found",
    backToSession: "返回到辅导环节",
  },
};
